import {
  CatalogCategoryListParam,
  CatalogCompanyListParam,
  CatalogItemListParam,
  CountCatalogItemsInSearchParams,
  CountCatalogItemsInSearchResponse,
  SearchAutoCompleteParams,
  SearchAutoCompleteResponse,
  SupplierReviewsQueryParam,
  SupplierReviewSummaryResponse,
} from '@/shared/types/api/catalog';
import { CatalogCategory, CatalogCompany, CatalogItem, SupplierReview } from '@/shared/types/catalog';
import axios from '@/shared/utils/axios';

export async function getCatalogCompanyByHandle(handle: string) {
  const { data } = await axios.get<CatalogCompany>(`/app/catalog-companies/${handle}`);
  return data;
}

export async function getCatalogCompanies(params: CatalogCompanyListParam) {
  const { data } = await axios.get<ListResponse<CatalogCompany>>('/app/catalog-companies', { params });
  return data;
}

export async function getCatalogCompaniesByIds(ids: number[] | string[]) {
  const { data } = await axios.get<ListResponse<CatalogCompany>>(
    `/app/catalog-companies/${ids.join()}?alwaysList=true`,
  );
  return data;
}

export async function getCatalogItemByHandle(handle: string) {
  const { data } = await axios.get<CatalogItem>(`/app/catalog-items/${handle}`);
  return data;
}

export async function getCatalogItems(params: CatalogItemListParam) {
  const { data } = await axios.get<ListResponse<CatalogItem>>('/app/catalog-items', { params });
  return data;
}

export async function getCatalogCategories(params: CatalogCategoryListParam) {
  const { data } = await axios.get<ListResponse<CatalogCategory>>('/app/catalog-categories', { params });
  return data;
}

export async function getCatalogCompanyReviews(params: SupplierReviewsQueryParam) {
  const { data } = await axios.get<ListResponse<SupplierReview>>('/app/catalog-company-reviews', { params });
  return data;
}

export async function getCatalogCompanyReviewSummary(supplierId: number, itemId?: number) {
  const params = {
    itemId,
  };
  const { data } = await axios.get<SupplierReviewSummaryResponse>(
    `/app/catalog-company-reviews/-/summary/${supplierId}`,
    { params },
  );
  return data;
}

export async function countCatalogItemsInSearch(params: CountCatalogItemsInSearchParams) {
  const { data } = await axios.get<CountCatalogItemsInSearchResponse>('/app/catalog-items/action/category-group', {
    params,
  });
  return data;
}

export async function getSearchAutoComplete(params: SearchAutoCompleteParams) {
  const { data } = await axios.get<SearchAutoCompleteResponse>('/app/catalog-items/action/suggest-auto-complete', {
    params,
  });
  return data;
}

export const categoryCountBySuppliersInSearch = async (params: CountCatalogItemsInSearchParams) => {
  const { data } = await axios.get('/app/catalog-companies/action/category-group', {
    params,
  });
  return data;
};

export const categoryCountByProductsInSearch = async (params: CountCatalogItemsInSearchParams) => {
  const { data } = await axios.get('/app/catalog-items/action/category-group', { params });
  return data;
};
